import { combineReducers } from '@reduxjs/toolkit';
import authReducer from '../modules/auth/authSlice';

const rootReducer = combineReducers({
  authReducer,
});

export default rootReducer;
